import { Punkt } from '../_classes/list/punkt';

export let Punkts: Punkt[] = [
  {id: 1, name: 'Органы государственной власти и органы местного самоуправления', status: true},
  {id: 2, name: 'Отделения Пенсионного фонда РФ по Челябинской области и управления Пенсионного Фонда РФ по районам города Челябинска', status: true},
  {id: 3, name: 'Помещения, занимаемые районными общественными организациями инвалидов', status: true},
  {id: 4, name: 'Вокзалы,  аэропорт (при отправке к месту реабилитации, по завершению курса реабилитации)', status: true},
  {id: 5, name: 'Учреждения, клиники, центры, предоставляющие медицинские услуги', status: true},
  {id: 6, name: 'Спортивно-оздоровительные учреждения, предоставляющие услуги по адаптивной физической культуре для инвалидов', status: true},
  {id: 7, name: 'Культурно - досуговые учреждения, при условии прохождения в них творческой реабилитации', status: true},
  {id: 8, name: 'Учреждениям медико-социальной экспертизы', status: true},
  {id: 9, name: 'Органы социальной защиты и учреждения социального обслуживания населения', status: true},
  {id: 10, name: 'Протезно-ортопедические предприятия', status: true},
  {id: 11, name: 'Челябинские региональные отделения Фонда социального страхования Российской Федерации', status: true},
  {id: 12, name: 'Кредитные организациии (банки)', status: true},
  {id: 13, name: 'Почтовые отделения', status: true}
]



// WEBPACK FOOTER //
// /usr/home/rob/Staxi/client/src/app/_mock/punkts.ts